import { Header } from "components/atoms";
import { Footer } from "components/atoms/footer";
import joinClasses from "helpers/joinClasses";
import React from "react";

export function Template({
  children,
  backgroundColor = "bg-primary-lightest",
  dark = false,
}) {
  return (
    <div
      className={joinClasses(
        "min-h-screen max-w-screen overflow-hidden transition-all duration-300 ease-in-out relative bg-cover bg-center bg-no-repeat",
        backgroundColor
      )}
      style={{
        backgroundImage: `url(/assets/brand/bg.jpg)`,
      }}
    >
      {/* <Header /> */}
      <main>{children}</main>
      {/* <Footer dark={dark} /> */}
    </div>
  );
}
